export default function DiscountBadge({
  discountPercent,
  size = 'md',
  className = ''
}) {
  if (!discountPercent || discountPercent <= 0) return null

  const sizeConfig = {
    sm: { width: 35, height: 35, percentSize: 14, strokeWidth: 2 },
    md: { width: 42, height: 42, percentSize: 18, strokeWidth: 2 },
    lg: { width: 48, height: 48, percentSize: 21, strokeWidth: 2.4 }
  }

  const config = sizeConfig[size] || sizeConfig.md

  return (
    <div
      className={`relative ${className}`}
      style={{ width: config.width, height: config.height }}
      aria-label={`${discountPercent}% discount available`}
    >
      <svg
        width={config.width}
        height={config.height}
        viewBox="0 0 52 52"
        className="drop-shadow-lg"
        xmlns="http://www.w3.org/2000/svg"
      >
        {/* White circle outline */}
        <circle
          cx="26"
          cy="26"
          r="24"
          fill="none"
          stroke="white"
          strokeWidth={config.strokeWidth}
        />

        {/* Percentage symbol (left-center) */}
        <text
          x="18"
          y="32"
          fontSize={config.percentSize}
          fontWeight="bold"
          textAnchor="middle"
          fill="white"
        >
          %
        </text>

        {/* Down arrow (right side of %) with spacing */}
        <path
          d="M34 15 L34 35 M30 31 L34 35 L38 31"
          stroke="white"
          strokeWidth={config.strokeWidth}
          strokeLinecap="round"
          strokeLinejoin="round"
          fill="none"
        />
      </svg>
    </div>
  )
}
